/* Lumoveo theme behaviour. Plain JS, no dependencies. Every feature is opt-in by data attribute. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const pad = n => String(n).padStart(2, '0');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const onScroll = fn => { let q = false; addEventListener('scroll', () => { if (!q) { q = true; requestAnimationFrame(() => { q = false; fn(); }); } }, { passive: true }); };

  /* ---------- Countdown: rolls to 23:59:59 tonight, local time, every day ---------- */
  const nextDeadline = () => { const t = new Date(); t.setHours(23, 59, 59, 999); return t; };
  let deadline = nextDeadline();
  function tick() {
    let ms = deadline - Date.now();
    if (ms <= 0) { deadline = nextDeadline(); ms = deadline - Date.now(); }
    const s = Math.floor(ms / 1000);
    const h = Math.floor(s / 3600), m = Math.floor(s / 60) % 60, sec = s % 60;
    $$('[data-countdown]').forEach(el => {
      el.innerHTML = el.dataset.countdown === 'clock'
        ? `${pad(h)}:${pad(m)}:${pad(sec)}`
        : `${pad(h)}<i>h</i> ${pad(m)}<i>m</i> ${pad(sec)}<i>s</i>`;
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- Buy box timer: pulses for its first 5 seconds in view ---------- */
  const bt = $('.buy-timer');
  if (bt && !reduce) {
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect(); bt.classList.add('is-pulse');
      setTimeout(() => bt.classList.remove('is-pulse'), 5000);
    }, { threshold: 0.8 });
    io.observe(bt);
  }

  /* ---------- Delivery estimate in working days ---------- */
  const addWorkingDays = (from, n) => { const d = new Date(from); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
  const fmt = d => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  $$('[data-delivery]').forEach(el => {
    const now = new Date();
    el.textContent = `${fmt(addWorkingDays(now, +el.dataset.min || 6))} and ${fmt(addWorkingDays(now, +el.dataset.max || 9))}`;
  });

  /* ---------- Product state (all money strings are formatted by Shopify) ---------- */
  const pj = $('[data-product-json]');
  const P = pj ? JSON.parse(pj.textContent) : null;
  const state = { i: 0, qty: 1 };
  if (P) {
    const checked = $('[data-size][aria-checked="true"]');
    const idx = checked ? P.variants.findIndex(v => String(v.id) === checked.dataset.size) : 0;
    state.i = idx < 0 ? 0 : idx;
  }
  const setAll = (sel, text) => $$(sel).forEach(el => { if (text == null) { el.hidden = true; } else { el.hidden = false; el.textContent = text; } });

  let rolled = false;
  function setStock(n, animate) {
    const row = $('[data-stock-row]');
    if (!row) return;
    row.hidden = !(n > 0 && n <= (P.stockThreshold || 15));
    const el = $('[data-stock]', row);
    if (!animate || reduce) { el.innerHTML = `<span class="odo"><span>${n}</span></span>`; return; }
    el.innerHTML = `<span class="odo"><span class="odo__reel"><span>${n + 1}</span><span>${n}</span></span></span>`;
    setTimeout(() => el.querySelector('.odo__reel')?.classList.add('is-rolled'), 7000);
  }
  function render() {
    if (!P) return;
    const v = P.variants[state.i], two = state.qty === 2;
    setAll('[data-price]', two ? v.p2 : v.p1);
    setAll('[data-compare]', two ? v.c2 : v.c1);
    const save = two ? v.s2 : v.s1;
    setAll('[data-save]', save ? `${P.savePrefix} ${save}` : null);
    $$('[data-then]').forEach(el => { if (v.c1) el.textContent = v.c1; });
    $$('[data-size-label]').forEach(el => { el.textContent = v.label; });
    $$('[data-tier-price="1"]').forEach(el => { el.textContent = v.p1; });
    $$('[data-tier-price="2"]').forEach(el => { el.textContent = `${v.each2} ${P.each}`; });
    $$('[data-tier-was]').forEach(el => { if (v.c1) { el.hidden = false; el.textContent = el.closest('[data-qty="2"]') ? `${v.c1} ${P.each}` : v.c1; } else el.hidden = true; });
    $$('[data-size]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.size === String(v.id))));
    $$('[data-qty]').forEach(b => b.setAttribute('aria-checked', String(+b.dataset.qty === state.qty)));
    $$('[data-variant-input]').forEach(el => { el.value = v.id; });
    $$('[data-qty-input]').forEach(el => { el.value = state.qty; });
    $$('[data-add], [data-buy-now], [data-sticky-add]').forEach(b => { b.disabled = !v.available; });
    if (!rolled) setStock(v.stock, false); else setStock(v.stock, false);
  }
  $$('[data-size]').forEach(b => b.addEventListener('click', () => {
    state.i = Math.max(0, P.variants.findIndex(v => String(v.id) === b.dataset.size));
    render();
  }));
  $$('[data-qty]').forEach(b => b.addEventListener('click', () => { state.qty = +b.dataset.qty; render(); }));
  const stockRow = $('[data-stock-row]');
  if (P && stockRow) {
    new IntersectionObserver((es, io) => {
      if (es[0].isIntersecting && !rolled) { rolled = true; setStock(P.variants[state.i].stock, true); io.disconnect(); }
    }, { threshold: 0.6 }).observe(stockRow);
  }

  /* ---------- Viewers line: owner-set range, drifts gently ---------- */
  const viewers = $('[data-viewers]');
  if (viewers) {
    const min = +viewers.dataset.min, max = +viewers.dataset.max, out = $('[data-viewers-n]', viewers);
    let n = Math.round(min + Math.random() * (max - min));
    out.textContent = n;
    setInterval(() => { n = Math.min(max, Math.max(min, n + (Math.random() < 0.5 ? -1 : 1))); out.textContent = n; }, 9000);
  }

  /* ---------- Cart: add, then basket or checkout ---------- */
  async function addToCart(checkout, btn) {
    if (!P) return;
    const v = P.variants[state.i];
    const msg = $('[data-form-msg]');
    btn && (btn.disabled = true);
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: state.qty }] }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to basket');
      }
      location.href = root + (checkout ? 'checkout' : 'cart');
    } catch (e) {
      if (msg) { msg.textContent = e.message; msg.hidden = false; }
      btn && (btn.disabled = false);
    }
  }
  const form = $('[data-buy-form]');
  if (form) form.addEventListener('submit', e => {
    e.preventDefault();
    const b = e.submitter;
    addToCart(!!(b && b.hasAttribute('data-buy-now')), b);
  });
  $$('[data-sticky-add]').forEach(b => b.addEventListener('click', () => addToCart(false, b)));

  /* ---------- Sticky bar: only once the buy box's own button is above the screen ---------- */
  const sticky = $('[data-sticky]');
  const actions = $('[data-buybox] .actions');
  if (sticky) {
    if (!actions) sticky.remove();
    else {
      const img = $('[data-sticky-img]', sticky); if (P && P.image && img) img.src = P.image;
      const check = () => sticky.classList.toggle('is-on', actions.getBoundingClientRect().bottom < 0);
      onScroll(check); addEventListener('resize', check); check();
    }
  }

  /* ---------- Header: transparent over the hero, solid after the announcement ---------- */
  const hdr = $('[data-header]'), ann = $('[data-ann]');
  if (hdr) {
    const update = () => hdr.classList.toggle('is-solid', scrollY > (ann ? ann.offsetHeight : 0) + 4 || !$('[data-hero]'));
    onScroll(update); update();
  }

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(g => {
    const main = $('[data-gallery-main]', g);
    $$('[data-thumb]', g).forEach(t => t.addEventListener('click', () => {
      if (t.dataset.thumbSet) main.srcset = t.dataset.thumbSet; else main.removeAttribute('srcset');
      main.src = t.dataset.thumb;
      $$('[data-thumb]', g).forEach(x => x.setAttribute('aria-current', String(x === t)));
    }));
  });

  /* ---------- Drawers (buy box and FAQ) open and close smoothly ---------- */
  $$('.drawers details, .faq details').forEach(d => {
    const sum = d.querySelector('summary'); if (!sum) return;
    const wrap = document.createElement('div'); wrap.className = 'dr';
    while (sum.nextSibling) wrap.appendChild(sum.nextSibling);
    d.appendChild(wrap);
    if (reduce) return;
    let anim = null;
    sum.addEventListener('click', e => {
      e.preventDefault();
      if (anim) anim.cancel();
      const opening = !d.open || d.classList.contains('is-closing');
      if (opening) {
        d.classList.remove('is-closing'); d.open = true;
        const h = wrap.scrollHeight;
        anim = wrap.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.22,1,.36,1)' });
        anim.onfinish = () => { anim = null; };
      } else {
        d.classList.add('is-closing');
        const h = wrap.offsetHeight;
        anim = wrap.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.4,0,.2,1)' });
        anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); anim = null; };
      }
    });
  });

  /* ---------- Modes tabs: descriptions slide open and closed like the drawers ---------- */
  $$('[data-tabs]').forEach(sec => {
    const tabs = $$('[data-tab]', sec);
    // wrap each description so its height can animate (margins included)
    $$('.mode p[data-panel]', sec).forEach(p => {
      const w = document.createElement('div'); w.className = 'mode__txt'; w.dataset.txt = p.dataset.panel;
      p.parentNode.insertBefore(w, p); w.appendChild(p); p.removeAttribute('data-panel');
      w.hidden = p.hidden; p.hidden = false;
    });
    const anims = new Map();
    const slide = (w, open) => {
      anims.get(w)?.cancel();
      if (reduce) { w.hidden = !open; return; }
      if (open) {
        w.hidden = false; const h = w.scrollHeight;
        const a = w.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.22,1,.36,1)' });
        anims.set(w, a); a.onfinish = () => anims.delete(w);
      } else {
        if (w.hidden) return;
        const h = w.offsetHeight;
        const a = w.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.4,0,.2,1)' });
        anims.set(w, a); a.onfinish = () => { w.hidden = true; anims.delete(w); };
      }
    };
    tabs.forEach(t => t.addEventListener('click', () => {
      if (t.getAttribute('aria-selected') === 'true') return;
      tabs.forEach(x => x.setAttribute('aria-selected', String(x === t)));
      $$('[data-panel]', sec).forEach(p => { p.hidden = p.dataset.panel !== t.dataset.tab; });
      $$('.mode__txt', sec).forEach(w => slide(w, w.dataset.txt === t.dataset.tab));
      if (t.dataset.glow) sec.style.setProperty('--mode-glow', t.dataset.glow);
    }));
    const first = tabs[0]; if (first && first.dataset.glow) sec.style.setProperty('--mode-glow', first.dataset.glow);
  });

  /* ---------- Section tints: the room picks up colour as you scroll ---------- */
  const tinted = $$('[data-tint]');
  if (tinted.length) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      const [a, b] = e.target.dataset.tint.split(',');
      document.documentElement.style.setProperty('--tint', a);
      document.documentElement.style.setProperty('--tint2', b || a);
    }), { rootMargin: '-45% 0px -45% 0px' });
    tinted.forEach(el => io.observe(el));
  }

  /* ---------- Room light pattern follows scroll progress ---------- */
  const room = $('.room');
  if (room && !reduce) {
    const shape = () => {
      const p = scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight);
      const t = p * Math.PI * 2;
      const v = {
        x1: 14 + 34 * Math.sin(t * 1.5), y1: 12 + 22 * (0.5 - 0.5 * Math.cos(t * 2.2)),
        x2: 86 - 30 * Math.sin(t * 1.2 + 1), y2: 88 - 24 * (0.5 - 0.5 * Math.cos(t * 1.7)),
        x3: 50 + 36 * Math.sin(t * 2.6 + 2), y3: 40 + 26 * Math.sin(t * 1.9 + 0.5),
      };
      for (const k in v) room.style.setProperty('--' + k, v[k].toFixed(2) + '%');
    };
    onScroll(shape); shape();
  }

  /* ---------- Parallax: night cards ---------- */
  const drifts = $$('[data-drift]');
  if (!reduce && drifts.length) {
    const pos = el => { const r = el.getBoundingClientRect(); return (r.bottom < 0 || r.top > innerHeight) ? null : (r.top + r.height / 2 - innerHeight / 2) / innerHeight; };
    const drift = () => {
      drifts.forEach(img => { const p = pos(img.parentElement); if (p != null) img.style.transform = `translateY(${(p * -64).toFixed(1)}px) scale(1.24)`; });
    };
    onScroll(drift); drift();
  }

  /* ---------- Feed videos: load before they reach the screen, then always play ---------- */
  const feedVids = $$('[data-feed] video');
  if (feedVids.length) {
    const start = v => { if (!v.src && v.dataset.src) v.src = v.dataset.src; v.muted = true; v.play().catch(() => {}); };
    // cards sit off to the side inside a clipped rail, so watch the section, not each card
    const rail = $('[data-feed]').parentElement;
    const loader = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { feedVids.forEach(start); loader.disconnect(); } }, { rootMargin: '1500px 0px' });
    loader.observe(rail);
    feedVids.forEach(v => v.addEventListener('pause', () => { if (!reduce && v.src) v.play().catch(() => {}); }));
  }

  /* ---------- Carousels on touch screens ----------
     Desktop keeps the CSS glide with pause on hover. On touch screens the track is moved with a
     transform on a true loop (offset kept modulo one copy, so there is no start or end). A sideways
     swipe drags it with momentum and hands control to the visitor; vertical scrolling stays native
     (touch-action: pan-y). Scrolling the section out of view and back resumes the glide. */
  if (matchMedia('(hover: none), (pointer: coarse)').matches) {
    $$('[data-carousel]').forEach(rail => {
      const track = rail.firstElementChild;
      if (!track) return;
      rail.classList.add('is-touch');
      const kids = [...track.children];
      let P = 0;
      const measure = () => { const h = kids.length / 2 | 0; P = h ? kids[h].offsetLeft - kids[0].offsetLeft : track.scrollWidth / 2; };
      measure(); addEventListener('resize', measure);
      const speed = () => P / ((+rail.dataset.duration || 70) * 1000); // px per ms
      let x = 0, auto = !reduce, visible = false, userStopped = false, last = 0;
      let dragging = false, decided = false, sx = 0, sy = 0, x0 = 0, v = 0, lastMoveX = 0, lastMoveT = 0;
      const mod = n => P ? ((n % P) + P) % P : 0;
      const draw = () => { track.style.transform = `translate3d(${-x}px,0,0)`; };
      const frame = t => {
        const dt = last ? Math.min(64, t - last) : 16; last = t;
        if (visible && !dragging) {
          if (auto) x = mod(x + speed() * dt);
          else if (Math.abs(v) > 0.01) { x = mod(x + v * dt); v *= Math.pow(0.95, dt / 16); }
          draw();
        }
        requestAnimationFrame(frame);
      };
      rail.addEventListener('touchstart', e => {
        const t = e.touches[0]; sx = t.clientX; sy = t.clientY; x0 = x; decided = false; dragging = false;
        lastMoveX = t.clientX; lastMoveT = performance.now(); v = 0;
      }, { passive: true });
      rail.addEventListener('touchmove', e => {
        const t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (!decided) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          decided = true;
          if (Math.abs(dx) <= Math.abs(dy)) return; // vertical: let the page scroll
          dragging = true; auto = false; userStopped = true;
        }
        if (!dragging) return;
        x = mod(x0 - dx); draw();
        const now = performance.now();
        if (now > lastMoveT) { v = -(t.clientX - lastMoveX) / (now - lastMoveT); lastMoveX = t.clientX; lastMoveT = now; }
      }, { passive: true });
      const end = () => { if (dragging) { dragging = false; v = Math.max(-3, Math.min(3, v)); } };
      rail.addEventListener('touchend', end, { passive: true });
      rail.addEventListener('touchcancel', end, { passive: true });
      new IntersectionObserver(([e]) => {
        visible = e.isIntersecting;
        if (!visible && userStopped) { userStopped = false; auto = !reduce; v = 0; }
      }).observe(rail);
      draw(); requestAnimationFrame(frame);
    });
  }

  /* ---------- In-page links land just above the section heading ---------- */
  const hdrH = () => { const h = $('.hdr-sec'); return h ? h.offsetHeight : 0; };
  const burger = $('[data-burger]'), drawer = $('[data-drawer]');
  const closeDrawer = () => { if (drawer) { drawer.hidden = true; burger && burger.setAttribute('aria-expanded', 'false'); } };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || !a.hash || a.hash.length < 2) return;
    let sec; try { sec = $(a.hash); } catch (_) { return; }
    if (!sec) return;
    e.preventDefault();
    closeDrawer();
    const mark = $('.head, .buy__grid', sec) || sec;
    const gap = Math.round(Math.min(64, Math.max(40, innerWidth * 0.045)));
    const target = () => { let y = 0, n = mark; while (n) { y += n.offsetTop; n = n.offsetParent; } return y - hdrH() - gap; };
    scrollTo({ top: target(), behavior: reduce ? 'auto' : 'smooth' });
    let done = false;
    const settle = () => { if (done) return; done = true; if (Math.abs(scrollY - target()) > 3) scrollTo({ top: target(), behavior: 'auto' }); };
    addEventListener('scrollend', settle, { once: true });
    setTimeout(settle, 2200);
    history.replaceState(null, '', a.hash);
  });

  /* ---------- Arriving from another page with a #section link: same landing gap ---------- */
  if (location.hash.length > 1) {
    let sec = null; try { sec = $(location.hash); } catch (_) {}
    if (sec) {
      const mark = $('.head, .buy__grid', sec) || sec;
      const land = () => { const gap = Math.round(Math.min(64, Math.max(40, innerWidth * 0.045))); let y = 0, n = mark; while (n) { y += n.offsetTop; n = n.offsetParent; } scrollTo({ top: y - hdrH() - gap, behavior: 'auto' }); };
      requestAnimationFrame(land);
      addEventListener('load', () => setTimeout(land, 60), { once: true });
    }
  }

  /* ---------- Mobile menu ---------- */
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const open = drawer.hidden;
      drawer.hidden = !open;
      burger.setAttribute('aria-expanded', String(open));
    });
    drawer.addEventListener('click', e => { if (e.target === drawer) closeDrawer(); });
    addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Scroll reveals ---------- */
  const reveals = $$('.reveal');
  if (reduce || !('IntersectionObserver' in window)) reveals.forEach(el => el.classList.add('is-in'));
  else {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(el => io.observe(el));
  }

  /* ---------- Hero: room photo, TV clips, live glow ---------- */
  const hero = $('[data-hero]');
  if (hero) {
    const mobile = matchMedia('(max-width: 899px)').matches;
    const img = $('[data-photo]', hero), tv = $('[data-tv]', hero), frame = $('[data-frame]', hero), video = $('[data-video]', hero);
    const box = (mobile ? hero.dataset.boxM : hero.dataset.boxD).split(',').map(Number);
    const frameBox = [box[0] - 5, box[1] - 5, box[2] + 10, box[3] + 10];
    const fit = mobile
      ? { tvWidth: cw => cw * 0.86, cy: 0.42, coverY: false }
      : { tvWidth: (cw, ch) => Math.min(cw * 0.44, ch * 0.95), cy: 0.52 };
    const clips = JSON.parse($('[data-clips]', hero).textContent || '[]');

    // Fit the TV into the space between the subtext and the price bar, with a guaranteed gap.
    let syncMeasure = null;
    const place = () => {
      const W = img.naturalWidth, H = img.naturalHeight;
      if (!W) return;
      const cw = hero.clientWidth, ch = hero.clientHeight;
      const hr = hero.getBoundingClientRect();
      const textEl = $('.hero__kicker', hero) || $('h1', hero);
      const bar = $('.hero__bar', hero);
      const gapTop = Math.round(Math.min(48, Math.max(28, ch * 0.04)));
      const gapBottom = mobile ? 20 : 28;
      const top = textEl.getBoundingClientRect().bottom - hr.top + gapTop;
      const bottom = bar.getBoundingClientRect().top - hr.top - gapBottom;
      const fh = frameBox[3], fw = frameBox[2];
      const kWant = fit.tvWidth(cw, ch) / box[2];
      const kFit = Math.max(0, bottom - top) / fh;
      const kMin = (mobile ? cw * 0.62 : cw * 0.26) / fw;
      const k = Math.max(kMin, Math.min(kWant, kFit));
      // centred horizontally; vertically centred in the free space, never above `top`
      const tx = (box[0] + box[2] / 2) * k;
      const spare = Math.max(0, (bottom - top) - fh * k);
      const frameTop = top + spare / 2;
      let ox = cw / 2 - tx;
      let oy = frameTop - frameBox[1] * k;
      const narrow = W * k < cw, short = H * k < ch;
      if (!narrow) ox = Math.min(0, Math.max(cw - W * k, ox));
      if (!short) oy = Math.min(0, Math.max(ch - H * k, oy));
      img.classList.toggle('is-short', short || oy > 0 || oy + H * k < ch);
      img.classList.toggle('is-narrow', narrow || ox > 0 || ox + W * k < cw);
      Object.assign(img.style, { width: W + 'px', height: H + 'px', transformOrigin: '0 0', transform: `translate(${ox}px, ${oy}px) scale(${k})` });
      const put = (node, bx) => Object.assign(node.style, { left: ox + bx[0] * k + 'px', top: oy + bx[1] * k + 'px', width: bx[2] * k + 'px', height: bx[3] * k + 'px' });
      put(tv, box); put(frame, frameBox);
      // camera: tiny, centred, standing on the top edge of the TV
      const cam = $('[data-cam]', hero);
      if (cam) {
        const fw = frameBox[2] * k, fx = ox + frameBox[0] * k, fy = oy + frameBox[1] * k;
        const cw2 = Math.max(10, fw * 0.03), ch2 = cw2 * 401 / 376;
        Object.assign(cam.style, { width: cw2 + 'px', left: fx + fw / 2 - cw2 / 2 + 'px', top: fy - ch2 + Math.max(1, cw2 * 0.15) + 'px' });
      }
      // frosted band starts a little above the price bar's line, never over the TV
      const barTop = bar.getBoundingClientRect().top - hr.top;
      const tvBottom = oy + (frameBox[1] + frameBox[3]) * k;
      hero.style.setProperty('--blur-top', Math.max(tvBottom + 4, barTop - 56) + 'px');
      if (syncMeasure) syncMeasure();
      hero.classList.add('is-placed');
    };
    addEventListener('resize', place);
    document.fonts && document.fonts.ready.then(place);

    let ci = 0;
    video.crossOrigin = 'anonymous';
    // phone versions (1024px) only where the TV shows no more than ~1100 real pixels
    const small = () => frame.getBoundingClientRect().width * (devicePixelRatio || 1) <= 1100;
    const next = () => { if (!clips.length) return; const c = clips[ci++ % clips.length]; const s = small(); video.poster = (s && c.posterM) || c.poster; video.src = (s && c.srcM) || c.src; video.play().catch(() => {}); };
    if (clips.length > 1) video.addEventListener('ended', next); else video.loop = true;

    let started = false;
    const go = () => { if (started) return; started = true; place(); next(); syncMeasure = initSync({ video, canvas: $('[data-glow]', hero), tv: frame, spread: 0.95, hole: true, blur: 14 }); };
    img.addEventListener('load', go, { once: true });
    img.src = mobile ? hero.dataset.photoM : hero.dataset.photoD;
    if (img.complete && img.naturalWidth) go();

    const sw = $('[data-switch]', hero);
    sw && sw.addEventListener('click', () => {
      const on = sw.getAttribute('aria-checked') !== 'true';
      sw.setAttribute('aria-checked', String(on));
      hero.classList.toggle('is-off', !on);
    });
  }

  /* ---------- Live screen sync: sample the video's edges, paint light around the frame ---------- */
  function initSync(opts) {
    const { video, canvas, tv, zones = { x: 8, y: 5 }, spread = 1, hole = false, blur = 0 } = opts;
    const ctx = canvas.getContext('2d');
    const sw = 48, sh = 27;
    const sample = document.createElement('canvas');
    sample.width = sw; sample.height = sh;
    const sctx = sample.getContext('2d', { willReadFrequently: true });
    const n = zones.x * 2 + zones.y * 2;
    let cur = Array.from({ length: n }, () => [0, 0, 0]);
    let running = false, visible = true, frameN = 0, geo = null, painted = false, tainted = false;

    function measure() {
      const dpr = Math.min(devicePixelRatio || 1, 1.5) * 0.5;
      const r = canvas.getBoundingClientRect();
      canvas.width = Math.max(1, r.width * dpr);
      canvas.height = Math.max(1, r.height * dpr);
      const t = tv.getBoundingClientRect();
      geo = { s: dpr, x: (t.left - r.left) * dpr, y: (t.top - r.top) * dpr, w: t.width * dpr, h: t.height * dpr };
      if (painted) paint(cur);
    }
    function avg(d, x0, y0, x1, y1) {
      let r = 0, g = 0, b = 0, c = 0;
      for (let y = y0; y < y1; y++) for (let x = x0; x < x1; x++) { const i = (y * sw + x) * 4; r += d[i]; g += d[i + 1]; b += d[i + 2]; c++; }
      return [r / c, g / c, b / c];
    }
    function read() {
      sctx.drawImage(video, 0, 0, sw, sh);
      const d = sctx.getImageData(0, 0, sw, sh).data;
      const out = [], depth = 4, zx = sw / zones.x, zy = sh / zones.y;
      for (let i = 0; i < zones.x; i++) out.push(avg(d, Math.floor(i * zx), 0, Math.ceil((i + 1) * zx), depth));
      for (let i = 0; i < zones.y; i++) out.push(avg(d, sw - depth, Math.floor(i * zy), sw, Math.ceil((i + 1) * zy)));
      for (let i = zones.x - 1; i >= 0; i--) out.push(avg(d, Math.floor(i * zx), sh - depth, Math.ceil((i + 1) * zx), sh));
      for (let i = zones.y - 1; i >= 0; i--) out.push(avg(d, 0, Math.floor(i * zy), depth, Math.ceil((i + 1) * zy)));
      return out;
    }
    function boost([r, g, b]) {
      const mx = Math.max(r, g, b) || 1, mn = Math.min(r, g, b), k = 255 / mx, l = (mx + mn) / 2;
      return [r, g, b].map(c => Math.max(0, Math.min(255, (l + (c - l) * 1.25) * Math.min(k, 1.6))));
    }
    function paint(cols) {
      painted = true;
      const { x, y, w, h } = geo;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'lighter';
      if (blur && 'filter' in ctx) ctx.filter = `blur(${blur * geo.s}px)`;
      const rad = Math.max(w, h) * 0.34 * spread, inset = hole ? 0 : Math.min(w, h) * 0.04, push = hole ? 0.12 : 0.35;
      const pts = [];
      for (let i = 0; i < zones.x; i++) pts.push([x + (i + 0.5) * w / zones.x, y + inset, 0, -1]);
      for (let i = 0; i < zones.y; i++) pts.push([x + w - inset, y + (i + 0.5) * h / zones.y, 1, 0]);
      for (let i = zones.x - 1; i >= 0; i--) pts.push([x + (i + 0.5) * w / zones.x, y + h - inset, 0, 1]);
      for (let i = zones.y - 1; i >= 0; i--) pts.push([x + inset, y + (i + 0.5) * h / zones.y, -1, 0]);
      pts.forEach(([px, py, dx, dy], i) => {
        const [r, g, b] = boost(cols[i]);
        const cx = px + dx * rad * push, cy = py + dy * rad * push;
        const gr = ctx.createRadialGradient(cx, cy, 0, cx, cy, rad);
        gr.addColorStop(0, `rgba(${r | 0},${g | 0},${b | 0},0.55)`);
        gr.addColorStop(0.45, `rgba(${r | 0},${g | 0},${b | 0},0.18)`);
        gr.addColorStop(1, `rgba(${r | 0},${g | 0},${b | 0},0)`);
        ctx.fillStyle = gr;
        ctx.fillRect(cx - rad, cy - rad, rad * 2, rad * 2);
      });
      ctx.globalCompositeOperation = 'source-over';
      ctx.filter = 'none';
      if (hole) ctx.clearRect(x, y, w, h);
    }
    function safeRead() {
      try { return read(); } catch (_) { tainted = true; return null; }
    }
    function loop() {
      if (!running || tainted) return;
      if (visible && !document.hidden && video.readyState >= 2 && frameN++ % 2 === 0) {
        const next = safeRead();
        if (next) { cur = cur.map((c, i) => c.map((v, j) => v + (next[i][j] - v) * 0.22)); paint(cur); }
      }
      requestAnimationFrame(loop);
    }
    measure();
    addEventListener('resize', measure);
    document.fonts && document.fonts.ready.then(measure);
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(canvas);
    if (reduce) {
      video.pause();
      const still = () => { measure(); const r = safeRead(); if (r) { cur = r; paint(cur); } };
      if (video.readyState >= 2) still(); else video.addEventListener('loadeddata', still, { once: true });
      return measure;
    }
    const start = () => { if (!running) { running = true; loop(); } };
    video.addEventListener('playing', start);
    if (!video.paused) start();
    return measure;
  }

  render();
})();

/* ---------- cookie consent ----------
   Carried over from the Rosvalle theme. The answer is stored locally and the
   card comes down at once; the Customer Privacy API call follows as a side
   effect, so a slow API never leaves the card ignoring taps. Publishes
   --consent-h so the sticky buy bar can sit above it. */
(() => {
  const el = document.getElementById('tb-consent');
  if (!el) return;
  const KEY = 'tb:consent';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } };
  const write = (choice) => { try { localStorage.setItem(KEY, JSON.stringify({ choice, at: Date.now() })); } catch (e) {} };
  const root = document.documentElement.style;
  const setHeight = () => {
    root.setProperty('--consent-h', el.hidden ? '0px' : Math.max(0, innerHeight - el.getBoundingClientRect().top) + 'px');
  };
  const hide = () => {
    el.classList.remove('on');
    root.setProperty('--consent-h', '0px');
    setTimeout(() => { el.hidden = true; }, 500);
  };
  const show = () => {
    el.hidden = false;
    requestAnimationFrame(() => { el.classList.add('on'); setHeight(); setTimeout(setHeight, 520); });
  };

  let cp = null;
  const push = (choice) => {
    if (!cp || !choice) return;
    const noop = () => {};
    try { cp.setTrackingConsent(choice, noop); }
    catch (err) { try { cp.setTrackingConsent(!!choice.analytics, noop); } catch (e2) {} }
  };

  el.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-consent]');
    if (!btn) return;
    const yes = btn.dataset.consent === 'all';
    const choice = { analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes };
    write(choice);
    hide();
    push(choice);
  });

  document.querySelectorAll('[data-consent-open]').forEach((btn) => {
    btn.hidden = false;
    btn.addEventListener('click', (ev) => { ev.preventDefault(); show(); });
  });

  const boot = (cb) => {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { cb(null); return; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
      (err) => { cb(!err && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null); });
  };

  const prior = read();
  if (prior && prior.choice) {
    boot((api) => { cp = api; push(prior.choice); });
  } else {
    boot((api) => {
      cp = api;
      if (!api) return;
      let needed = true;
      try { needed = api.shouldShowBanner(); } catch (e) {}
      if (needed || /[?&]consent=show/.test(location.search)) show();
    });
  }
  addEventListener('resize', () => { if (!el.hidden) setHeight(); }, { passive: true });
})();
